var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 4.16667H8V7.5H4.66667V4.16667ZM3 4.16667C3 3.24619 3.74619 2.5 4.66667 2.5H8C8.92047 2.5 9.66667 3.24619 9.66667 4.16667V7.5C9.66667 8.42047 8.92047 9.16667 8 9.16667H4.66667C3.74619 9.16667 3 8.42047 3 7.5V4.16667ZM13 4.16667H16.3333V7.5H13V4.16667ZM11.3333 4.16667C11.3333 3.24619 12.0795 2.5 13 2.5H16.3333C17.2538 2.5 18 3.24619 18 4.16667V7.5C18 8.42047 17.2538 9.16667 16.3333 9.16667H13C12.0795 9.16667 11.3333 8.42047 11.3333 7.5V4.16667ZM16.3333 12.5H13V15.8333H16.3333V12.5ZM13 10.8333C12.0795 10.8333 11.3333 11.5795 11.3333 12.5V15.8333C11.3333 16.7538 12.0795 17.5 13 17.5H16.3333C17.2538 17.5 18 16.7538 18 15.8333V12.5C18 11.5795 17.2538 10.8333 16.3333 10.8333H13ZM4.66667 12.5H8V15.8333H4.66667V12.5ZM3 12.5C3 11.5795 3.74619 10.8333 4.66667 10.8333H8C8.92047 10.8333 9.66667 11.5795 9.66667 12.5V15.8333C9.66667 16.7538 8.92047 17.5 8 17.5H4.66667C3.74619 17.5 3 16.7538 3 15.8333V12.5Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.01bbc57a25a047d1e658c5a4f13701ad.svg";
export { ForwardRef as ReactComponent };